import { listingsBasicApi } from '@wiggot/apis/new-apis/listings-api'
import { hexaServiceAPI } from '@wiggot/apis/new-apis/hexa-api'
import { IGeometry } from '../interfaces/geoInterfaces'
import { ESearchLevel } from '../../../../../types-library/src'
import { IHttpResponse } from '../interfaces/httpInterfaces'


interface IGetPolygonResponse {
  id: string
  geometry: IGeometry
  name: string
}

export const getPolygon = async (params: {
  center: {
    lat: number
    lng: number
  }
  searchLevel?: ESearchLevel
  withGeometry?: boolean
}): Promise<IHttpResponse<IGetPolygonResponse>> => {
  try {
    const {
      center: { lat, lng },
      searchLevel = ESearchLevel.STATE,
      withGeometry = false
    } = params

    const withGeometryValidated =
      withGeometry && searchLevel !== ESearchLevel.STATE

    const response = await hexaServiceAPI.get<IHttpResponse<IGetPolygonResponse>>(
      `/lookup?level=${searchLevel}&latitude=${lat}&longitude=${lng}&addGeometry=${withGeometryValidated}`
    )

    return {
      isSuccess: response.message !== 'Level data not found',
      data: response?.data,
      message: response?.message
    }
  } catch (error) {
    return {
      isSuccess: false,
      error
    }
  }
}

export interface IZoneResponse {
  type: string
  properties: IZoneProperties
  geometry: IGeometry
}

export interface IZoneProperties {
  zone_id: number
  cve_ent: string
  zone_name: string
  latitude: number
  longitude: number
}

export const getGeometryForZone = async (
  id: number
): Promise<IHttpResponse<IZoneResponse>> => {
  try {
    const res = await listingsBasicApi.get<IHttpResponse<IZoneResponse>>(
      `/listings-properties/zones/${id}`
    )
    return {
      isSuccess: true,
      data: res?.data
    }
  } catch (error) {
    return {
      isSuccess: false,
      error
    }
  }
}
